

import React from 'react';
import Logo from './Logo';

interface FooterProps {
    setView: (view: 'landing' | 'dashboard' | 'guest' | 'join' | 'session' | 'auth' | 'resetPassword' | 'terms' | 'privacy' | 'about' | 'help') => void;
    onManageCookies?: () => void;
}

const Footer: React.FC<FooterProps> = ({ setView, onManageCookies }) => {
  return (
    <footer className="w-full bg-white p-8 border-t border-gray-200">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Logo />
            <p className="text-gray-500 mt-2 text-sm">
              Making typing fun and accessible for every student.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Company</h3>
            <ul className="space-y-2">
              <li><button onClick={() => setView('about')} className="text-gray-600 hover:text-blue-600 text-left">About Us</button></li>
              <li><button className="text-gray-400 cursor-not-allowed text-left">Careers</button></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><button onClick={() => setView('terms')} className="text-gray-600 hover:text-blue-600 text-left">Terms &amp; Services</button></li>
              <li><button onClick={() => setView('privacy')} className="text-gray-600 hover:text-blue-600 text-left">Privacy Policy</button></li>
              {onManageCookies && <li><button onClick={onManageCookies} className="text-gray-600 hover:text-blue-600 text-left">Cookie Settings</button></li>}
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Support</h3>
            <ul className="space-y-2">
              <li><button onClick={() => setView('help')} className="text-gray-600 hover:text-blue-600 text-left">Help Center</button></li>
              <li><button className="text-gray-400 cursor-not-allowed text-left">Resources</button></li>
              <li><button className="text-gray-400 cursor-not-allowed text-left">Contact Support</button></li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-200 pt-6 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} TypeoGO. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;